/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsert/Description",
  onChange,
  invalid
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventActionDataDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.description',
})
let eventActionDataDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.description',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Description"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 placeholder="Enter description for the task"
 data="event_action.data.description"
 value={eventActionDataDescriptionValueData}
 onChange={eventActionDataDescriptionChangeData}
 invalid={invalid}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}